// Copyright (c) Frisbii GmbH. All rights reserved.
'use strict';

var OrderDetailsController = function ($scope, $routeParams, ProductInfo, PUtill, Order, OrderPaymentTransactions, $http, $location, $window, CustomFieldSettings, salesEntitiesService, gettextCatalog, gettext) {

    $scope.customer = [];
    $scope.contract = [];
    $scope.componentSubscriptions = [];
    $scope.meteredUsage = [];
    $scope.productInfo = ProductInfo.get(loadOrderDetails);

    $scope.discountSubscriptions = [];
    $scope.ledgerEntries = [];
    $scope.paymentTransactions = [];

    function checkCustomerFieldVisibility(orderCustomFieldSetting) {
        return orderCustomFieldSetting.EditInUI != 'None';
    }

    CustomFieldSettings.get({ customFieldType: "Order"}, function (data) {
        $scope.orderCustomFieldSettings = data.CustomFieldDescriptors.filter(checkCustomerFieldVisibility);
    });

    function loadOrderDetails() {
        $scope.order = Order.get({ orderId: $routeParams.orderId }, function () {
            $scope.customer = $scope.order.Customer;
            $scope.contract = $scope.order.Contract;
            $scope.componentSubscriptions = $scope.order.ComponentSubscriptions;
            $scope.meteredUsage = $scope.order.MeteredUsages;
            $scope.discountSubscriptions = $scope.order.DiscountSubscriptions;
            $scope.ratedItems = $scope.order.RatedItems;
            $scope.lineItems = $scope.order.LineItems;
            $scope.priceListName = $scope.productInfo.PriceLists.find(x => x.Id === $scope.order.PriceListId)?.InternalName;
            $scope.paymentTransactions = OrderPaymentTransactions.query({ orderId: $scope.order.Id });
            initSalesEntity();
        });
    }

    function initSalesEntity() {
        salesEntitiesService.query({}, function (response) {
            $scope.salesEntities = response;
            $scope.salesEntity = response.find(function (el) {
                return el.Id == $scope.contract.SalesEntityId;
            });

            if ($scope.salesEntity.IsDefault) {
                let defaultSuffix = " (" + gettextCatalog.getString(gettext('default')) + ")";
                $scope.salesEntity.InternalName += defaultSuffix;
            }
        });
    }

    $scope.statusClass = function (status) {
        return PUtill.getStatusClass(status);
    };

    $scope.approve = function() {
        $http({
            method: "POST",
            url: "/api/v1/orders/" + $scope.order.Id + "/approve"
        }).then(function (response) {
            $location.path("/contracts/" + response.data.Id);
        });
    };

    $scope.decline = function() {
        $http({
            method: "POST",
            url: "/api/v1/orders/" + $scope.order.Id + "/decline"
        }).then(function (response) {
            $scope.order = response.data;
        });
    };

    $scope.back = function () {
        $window.history.back();
    }
};
OrderDetailsController.$inject = ['$scope', '$routeParams', 'ProductInfo', 'PUtill', 'Order', 'OrderPaymentTransactions', '$http', '$location', '$window', 'CustomFieldSettings', 'SalesEntities', 'gettextCatalog', 'gettext'];
